/**
 * Copyright © 2026 Adnuntius AS.
 */
export function updateEndDateForManualInput(obj: any, param: string): void {
  if (obj[param] instanceof Date
    && obj[param].getMinutes() === 59
    && (obj[param].getSeconds() < 59 || obj[param].getMilliseconds() < 999)) {
    obj[param].setSeconds(59, 999);
  }
}
